module.exports = __webpack_public_path__ + "static/why-popup--3-79c6dfac69fb1ef035ed4f4bff00ab57.png";